import * as React from 'react';

import {
  TranslatedCMLViewer,
  TranslatedDangerouslySetHtml,
  TranslatedPlainText,
} from '@coursera-web/ondemand-translation';
import { omit as lodashOmit } from 'lodash';

import type { Content as ContentType } from 'bundles/cml';
import type { HTMLContent } from 'bundles/compound-assessments/types/FormParts';

type Props = {
  assumeStringIsHtml: boolean;
  content?: ContentType | HTMLContent;
  contentId?: string;
  display?: 'inline-block' | 'block';
  className?: string;
  enableTranslation?: boolean;
};

/**
 * Component similar to the static/bundles/phoenix/components/Content.tsx but utilizes new
 * ondemand-translation components.
 */
class TranslatedContent extends React.Component<Props> {
  static defaultProps = {
    assumeStringIsHtml: false,
  };

  render() {
    const { assumeStringIsHtml, content, enableTranslation } = this.props;
    if (content) {
      if (typeof content !== 'string' && content.typeName === 'cml') {
        const passThroughProps = lodashOmit(this.props, 'assumeStringIsHtml', 'content', 'enableTranslation');
        return <TranslatedCMLViewer cml={content} enableTranslation={enableTranslation} {...passThroughProps} />;
      } else if (typeof content !== 'string' && content.typeName === 'htmlText') {
        return <TranslatedDangerouslySetHtml html={content.definition.content} enableTranslation={enableTranslation} />;
      } else if (typeof content !== 'string' && content.typeName === 'html') {
        return <TranslatedDangerouslySetHtml html={content.definition} enableTranslation={enableTranslation} />;
      } else if (assumeStringIsHtml) {
        return <TranslatedDangerouslySetHtml html={content} enableTranslation={enableTranslation} />;
      } else {
        return (
          <span>
            <TranslatedPlainText plainText={content} enableTranslation={enableTranslation} />
          </span>
        );
      }
    } else {
      return false;
    }
  }
}

export default TranslatedContent;
